(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitanima-cyber-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timers = document.querySelectorAll('[data-vcy-end]');
    timers.forEach((timer) => {
      if (timer.dataset.ready) return;
      const end = Date.parse(timer.dataset.vcyEnd);
      if (!Number.isFinite(end)) return;
      timer.dataset.ready = 'true';
      const update = () => {
        const remaining = end - Date.now();
        timer.hidden = false;
        if (remaining <= 0) { timer.textContent = timer.dataset.expired; return false; }
        const minutes = Math.floor(remaining / 60000);
        timer.textContent = `${timer.dataset.label} ${Math.floor(minutes / 1440)} d · ${Math.floor(minutes / 60) % 24} h · ${minutes % 60} min`;
        return true;
      };
      if (update()) { const id = setInterval(() => { if (!update() || !timer.isConnected) clearInterval(id); }, 60000); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitanima-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-vt-search]')) return;
    const search = document.getElementById('search-modal');
    if (typeof search?.showDialog === 'function') {
      event.preventDefault();
      search.showDialog();
    }
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-vt-mobile-menu][open]').forEach((menu) => {
      const closeButton = event.target.closest('[data-vt-menu-close]');
      if (!menu.contains(event.target) || closeButton) {
        menu.open = false;
        if (closeButton) menu.querySelector('.vhm__toggle')?.focus();
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vt-mobile-menu][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('.vhm__toggle')?.focus();
    });
  });
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches('[data-vt-mobile-menu]')) return;
    const toggle = menu.querySelector('.vhm__toggle');
    toggle?.setAttribute('aria-label', menu.open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
  }, true);
  window.matchMedia('(min-width: 1280px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelectorAll('[data-vt-mobile-menu][open]').forEach((menu) => { menu.open = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitanima-mobile-check"]) return;
  try {
    
(function(){
  const frame=document.getElementById('vmqa-frame');
  if(!frame)return;
  document.querySelectorAll('[data-test-path]').forEach(function(button){
    button.addEventListener('click',function(){frame.src=button.dataset.testPath+'?preview_theme_id=192411468069';});
  });
  document.getElementById('vmqa-width').addEventListener('change',function(event){frame.width=event.target.value;});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitanima-resenas-franja"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-vt-band-pause]');
    if (!button) return;
    const band = button.closest('[data-vt-review-band]');
    const paused = band.dataset.paused !== 'true';
    band.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.textContent = paused ? button.dataset.playText : button.dataset.pauseText;
  });

  } catch(e) { console.error(e); }
})();
})();
